import {
  Icon,
  ListColumnHeader,
  MRT_Cell,
  MRT_ColumnDef,
  OverflowTooltip,
} from '@ouster/webviz-react-components';

import { useMemo } from 'react';

import { ArchitectSceneInfo } from '../../types';
import { formatDateTime } from '../../utils/driveUtil';

export const CREATOR_FILTER_KEY = 'created_by';

export const useArchitectSceneColumns = ({
  filters,
  setFilterAnchorEl,
  setSelectedColKeys,
}: {
  filters: Record<string, string[]>;
  setFilterAnchorEl: (ele: HTMLElement | null) => void;
  setSelectedColKeys: (keys: string[]) => void;
}): MRT_ColumnDef<ArchitectSceneInfo>[] =>
  useMemo(
    () => [
      {
        id: 'created_at',
        header: 'CREATED',
        accessorFn: (row) => row.createdAt,
        size: 180,
        minSize: 150,
        grow: false,
        enableColumnActions: false,
        Cell: ({ cell }: { cell: MRT_Cell<ArchitectSceneInfo> }) => {
          const date = cell.getValue<Date>();
          return date ? formatDateTime(date.toISOString()) : '';
        },
      },
      {
        id: CREATOR_FILTER_KEY,
        accessorKey: 'createdBy',
        header: 'CREATOR',
        enableColumnActions: true,
        size: 180,
        minSize: 150,
        grow: false,
        Header: (
          <ListColumnHeader
            filters={filters}
            keys={[CREATOR_FILTER_KEY]}
            title="CREATOR"
          />
        ),
        muiColumnActionsButtonProps: {
          children: <Icon icon="filter" />,
          onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            setFilterAnchorEl(event.currentTarget);
            setSelectedColKeys([CREATOR_FILTER_KEY]);
          },
          title: 'filter by CREATOR',
        },
      },
      {
        accessorKey: 'title',
        header: 'TITLE',
        enableSorting: false,
        enableColumnActions: false,
        size: 400,
        minSize: 200,
        grow: true,
        Cell: ({ cell }: { cell: MRT_Cell<ArchitectSceneInfo> }) => {
          const value = cell.getValue<string | null>() ?? '';
          return (
            <OverflowTooltip
              value={value}
              dataTestId="architect-scene-title-overflow-tooltip"
            />
          );
        },
      },
    ],
    [filters, setFilterAnchorEl, setSelectedColKeys]
  );
